import { NextPageWithLayout } from '@scorenco/next';

import { MobileLayout } from './index';

/**
 * Page Next "vide" utilisée par l'application mobile.
 *
 * WARNING: les pages au sens Next ne correspondent pas au routage une fois que
 * l'on passe en version mobile (le routage est géré côté client par
 * react-router). Ces pages n'existent que pour servir le layout, et, en mode
 * SSR, pour porter les getServerSideProps (fichiers `*.ssr.tsx`).
 */
export const createMobilePage = (): NextPageWithLayout => {
  const Page: NextPageWithLayout = () => <></>;
  Page.getLayout = MobileLayout.buildGetLayout();
  return Page;
};
